import MenuButton from "Components/Menu Button/MenuButton";
import { DrawerState, IDrawer } from "Utils/types";
import { FC, useEffect, useState } from "react";
import { trackEvent } from "shared/utils";

interface IMainDrawerContainer {
    buttonText: string;
    openDelay: number;
    shouldOpen: boolean;
    onDrawerChange: (flag: boolean) => void;
    drawerTrackingName: string;
    Drawer: FC<IDrawer>;
}

const MainDrawerContainer: FC<IMainDrawerContainer> = ({
    buttonText,
    openDelay,
    shouldOpen,
    onDrawerChange,
    drawerTrackingName,
    Drawer
}) => {
    const [drawerOpen, setDrawerOpen] = useState<boolean>(false);

    const onClick = (): void => {
        if (drawerOpen) onDrawerChange(false);
        setDrawerOpen(prevState => !prevState);
        trackEvent(`open-drawer/${drawerTrackingName}`);
    }

    useEffect(() => {
        setDrawerOpen(shouldOpen);
    }, [shouldOpen]);

    useEffect(() => {
        if (drawerOpen) onDrawerChange?.(drawerOpen);
    }, [drawerOpen])

    return (
        <>
            <MenuButton
                text={buttonText}
                revertMode={false}
                onClick={onClick}
            />
            <Drawer
                state={drawerOpen ? DrawerState.Open : DrawerState.Closed}
                openDelay={openDelay}
                onClose={() => {
                    onDrawerChange(false);
                    setDrawerOpen(false);
                }}
            />
        </>
    );
}

export default MainDrawerContainer;